export enum UserPermissionEnum {
  ADD_RECEIVER = '1028',
}
